import UIFetchService from '../Service/UIFetchService';
import { isEmpty, isNotEmpty, samplingConstants } from '../Service/Utils';

import React from 'react';
import {
    Button,
    Row,
    Col,
    Select,
    Input,
    Table,
    Modal,
    Space,
    Tag,
    Popconfirm,
    Upload,
    Image,
    message,
    Popover,
    Tooltip,
} from 'antd';
import {
    LeftOutlined,
    DeleteOutlined,
    EditOutlined,
    CopyOutlined,
    ApiOutlined,
    CloudUploadOutlined,
} from '@ant-design/icons';


class SamplingPageView extends React.Component {

    deltaHeight = 250

    constructor() {
        super();
        const projectName = localStorage.getItem('sampling-defs.projectName');
        this.state = {
            pageNo: 1,
            pageSize: 20,
            total: 0,
            pages: [],
            pageEditModalVisible: false,
            pageAssociatedEventsModalVisible: false,
            tableHeight: document.body.clientHeight - this.deltaHeight,
            filters: {
                projectName: null,
                apps: null
            },
            projectName: isEmpty(projectName) ? '' : projectName
        };
    }

    render() {
        return <>
            <Row style={{ textAlign: 'left', padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
                <Col style={{ margin: '0 20px 0 0' }}>
                    <span
                        style={{
                            color: 'gray',
                            cursor: 'pointer'
                        }}
                        onClick={() => window.location = '/real_time/sampling'}
                    ><LeftOutlined /> 返回</span>
                </Col>
                <Col>
                    <span>页面管理</span>
                </Col>
            </Row>
            <Row style={{ padding: '0 10px 0 10px', margin: '0 0 10px 0' }}>
                <Col style={{ alignSelf: 'center' }}>
                    <span>项目组：</span>
                </Col>
                <Col>
                    <Select
                        value={this.state.projectName}
                        onChange={projectName => this.refreshPages({ projectName })}
                        style={{ width: 260 }}
                    >
                        {samplingConstants.projects.map(project => <Select.Option value={project.value}>
                            {project.title + " (" + project.value + ")"}
                        </Select.Option>)}
                        <Select.Option value="">全部</Select.Option>
                    </Select>
                </Col>
                <Col flex="10px"></Col>
                <Col flex='400px'>
                    <Input.Search
                        value={this.state.key}
                        onChange={({ target: { value } }) => this.refreshPages({ key: value, pageNo: 1 })}
                        placeholder='输入页面名称/创建人搜索'
                    />
                </Col>
                <Col flex='auto'></Col>
                <Col>
                    <Button
                        size='small'
                        type='primary'
                        onClick={() => this.setState({
                            pageEditModalVisible: true,
                            idForEditing: undefined,
                        })}
                    >
                        新增页面
                    </Button>
                </Col>
            </Row>
            <Row style={{ padding: '0 10px 0 10px' }}>
                <Col flex='100%'>
                    <Table
                        dataSource={this.state.pages}
                        style={{
                            width: '100%'
                        }}
                        size='small'
                        bordered
                        rowKey='id'
                        scroll={{ y: this.state.tableHeight, x: 1200 }}
                        pagination={{
                            current: this.state.pageNo,
                            pageSize: this.state.pageSize,
                            total: this.state.total,
                        }}
                        onChange={(pagination, filters, sorter, { action }) => {
                            this.refreshPages({
                                pageNo: pagination.current,
                                pageSize: pagination.pageSize,
                                filters
                            });
                        }}
                    >
                        <Table.Column
                            title='ID'
                            dataIndex='id'
                            width={80}
                            render={id => <Tag>{id}</Tag>}
                        />
                        <Table.Column
                            title='页面图片'
                            dataIndex='pictureStorageKey'
                            key='pictureStorageKey'
                            width={100}
                            render={pictureStorageKey => isEmpty(pictureStorageKey)
                                ? <span style={{ fontSize: 12, color: 'gray' }}>[未上传图片]</span>
                                : <Image
                                    src={`/api/v1/sampling/pictures/preview?key=${encodeURI(pictureStorageKey)}`}
                                    height={50}
                                />}
                        />
                        <Table.Column
                            title='页面名称'
                            dataIndex='name'
                            width={200}
                            render={(name, { id }) => <Button
                                type='link'
                                size='small'
                                style={{ padding: '0 0 0 0' }}
                                onClick={() => this.setState({ pageEditModalVisible: true, idForEditing: id })}
                            >
                                {name}
                            </Button>}
                        />
                        <Table.Column
                            title='页面描述'
                            dataIndex='comment'
                            width={200}
                            ellipsis
                        />
                        <Table.Column
                            title='页面链接'
                            dataIndex='link'
                            width={200}
                            ellipsis
                        />
                        <Table.Column
                            title='所属项目组'
                            dataIndex='projectName'
                            width={120}
                            //filters={samplingConstants.projects.map(p => { return { text: p.title, value: p.value } })}
                            render={projectName => {
                                const project = samplingConstants.projects.find(p => p.value === projectName);
                                if (project) {
                                    return <Tooltip title={project.value}>
                                        <span>{project.title}</span>
                                    </Tooltip>;
                                }
                            }}
                        />
                        <Table.Column
                            title='覆盖应用名'
                            dataIndex='apps'
                            width={300}
                            filters={this.appsOfProjects(this.state.filters.projectName).map(p => { return { text: p.title, value: p.value } })}
                            render={(apps) => <Space>{apps.map(key => {
                                const app = samplingConstants.apps.find(a => a.value === key);
                                if (app) {
                                    return <Tooltip title={app.value}>
                                        <Tag key={app.value}>{app.title}</Tag>
                                    </Tooltip>;
                                } else {
                                    return <></>;
                                }
                            })}</Space>}
                        />
                        <Table.Column
                            title='已关联事件'
                            dataIndex='associatedEvents'
                            width={100}
                            render={(associatedEvents, { id }) => <Popover
                                title='关联的事件，点击跳转到事件详情页'
                                content={<>
                                    {associatedEvents.map((e, key) => <Row key={key}>
                                        <Col>
                                            <Button
                                                size='small'
                                                type='link'
                                                href={`/real_time/sampling/edit/${e.id}`}
                                            >
                                                事件：{e.name}
                                            </Button>
                                        </Col>
                                    </Row>)}
                                </>}
                            >
                                <Button
                                    size='small'
                                    type='link'
                                    onClick={() => this.setState({ pageAssociatedEventsModalVisible: true, idForEditing: id })}
                                >
                                    {associatedEvents.length}
                                </Button>
                            </Popover>}
                        />
                        <Table.Column
                            title='创建人员'
                            dataIndex='creatorName'
                            width={80}
                        />
                        <Table.Column
                            title='创建时间'
                            dataIndex='createdAt'
                            width={160}
                        />
                        <Table.Column
                            title='更新人员'
                            dataIndex='updaterName'
                            width={80}
                        />
                        <Table.Column
                            title='更新时间'
                            dataIndex='updatedAt'
                            width={160}
                        />
                        <Table.Column
                            title='操作'
                            width={120}
                            fixed="right"
                            render={(_, { id, name }) => <Space size={2}>
                                <Tooltip title="编辑">
                                    <Button
                                        icon={<EditOutlined />}
                                        size="small"
                                        type='link'
                                        onClick={() => this.setState({
                                            pageEditModalVisible: true, idForEditing: id
                                        })}
                                    />
                                </Tooltip>
                                <Tooltip title="复制">
                                    <Button
                                        icon={<CopyOutlined />}
                                        size="small"
                                        type='link'
                                        onClick={async () => {
                                            const { pageId } = await UIFetchService.post(`/api/v1/sampling/pages/${id}/clone`, {});
                                            await this.refreshPages({});
                                            this.setState({
                                                pageEditModalVisible: true, idForEditing: pageId
                                            })
                                        }}
                                    />
                                </Tooltip>
                                <Tooltip title="关联事件">
                                    <Button
                                        icon={<ApiOutlined />}
                                        size="small"
                                        type='link'
                                        onClick={() => this.setState({ pageAssociatedEventsModalVisible: true, idForEditing: id })}
                                    />
                                </Tooltip>
                                <Popconfirm
                                    title={`是否删除页面：${name}？`}
                                    onConfirm={async () => {
                                        await UIFetchService.delete(`/api/v1/sampling/pages/${id}`, {});
                                        message.success('删除成功!');
                                        await this.refreshPages({});
                                    }}
                                >
                                    <Tooltip title="删除">
                                        <Button
                                            icon={<DeleteOutlined />}
                                            danger
                                            size="small"
                                            type='link'
                                        />
                                    </Tooltip>
                                </Popconfirm>
                            </Space>}
                        />
                    </Table>
                </Col>
            </Row>
            {this.state.pageEditModalVisible && <PageEditorModal
                visible={this.state.pageEditModalVisible}
                projectName={this.state.projectName}
                pageId={this.state.idForEditing}
                onCancel={() => this.setState({ pageEditModalVisible: false, idForEditing: undefined })}
                onDone={() => {
                    this.refreshPages({});
                    this.setState({ pageEditModalVisible: false });
                }}
            />}
            {this.state.pageAssociatedEventsModalVisible && <PageAssociatedEventsModal
                visible={this.state.pageAssociatedEventsModalVisible}
                projectName={this.state.projectName}
                pageId={this.state.idForEditing}
                onCancel={() => this.setState({ pageAssociatedEventsModalVisible: false, idForEditing: undefined })}
                onDone={() => {
                    this.refreshPages({});
                    this.setState({ pageAssociatedEventsModalVisible: false, idForEditing: undefined });
                }}
            />}
        </>;
    }

    async componentDidMount() {
        await this.refreshPages({});

        window.onresize = () => {
            this.setState({ tableHeight: document.body.clientHeight - this.deltaHeight });
        };
        window.onresize();
    }

    componentWillUnmount() {
        delete this.onresize;
    }

    appsOfProjects(names) {
        if (isEmpty(names)) {
            return samplingConstants.apps;
        }
        const apps = [];
        for (let key of names) {
            const project = samplingConstants.projects.find(p => p.value === key);
            if (project) {
                for (let app of project.children) {
                    apps.push(app);
                }
            }
        }
        return apps;
    }

    async refreshPages(params) {
        const keys = ['pageNo', 'pageSize', 'key', 'filters', 'projectName'];
        const queries = [];
        for (let key of keys) {
            if (params[key] === undefined) {
                params[key] = this.state[key];
            }

            if (key === 'filters') {
                queries.push(`${key}=${encodeURI(JSON.stringify(params[key]))}`);
            } else if (params[key] !== undefined) {
                queries.push(`${key}=${encodeURI(params[key])}`);
            }
        }
        localStorage.setItem('sampling-defs.projectName', params.projectName);
        this.setState({ ...params });
        const rv = await UIFetchService.get(`/api/v1/sampling/pages?${queries.join('&')}`);
        if (rv) {
            this.setState({ total: rv.total, pages: rv.items });
        }
    }
}

class PageEditorModal extends React.Component {
    constructor() {
        super();
        this.state = {
            associatedEvents: []
        };
    }

    render() {
        const redStar = <span style={{ color: 'red' }}>*</span>;
        return <Modal
            title={isEmpty(this.props.pageId) ? '新增页面' : '编辑页面'}
            {...this.props}
            maskClosable={false}
            onOk={isEmpty(this.props.pageId) ? this.add.bind(this) : this.save.bind(this)}
        >
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col>
                    {redStar}<span>页面名称：</span>
                </Col>
                <Col flex='auto'>
                    <Input
                        size='small'
                        value={this.state.name}
                        onChange={({ target: { value } }) => this.setState({ name: value, nameError: undefined })}
                    />
                </Col>
                {this.renderError('name')}
            </Row>
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col>
                    {redStar}<span>所属项目组：</span>
                </Col>
                <Col flex='auto'>
                    <Select
                        value={this.state.projectName}
                        onChange={projectName => this.setState({
                            projectName, apps: [],
                            projectNameError: undefined,
                            appsError: undefined
                        })}
                        size='small'
                        style={{
                            width: '100%'
                        }}
                    >
                        {samplingConstants.projects.map(p => <Select.Option key={p.value} value={p.value}>
                            {p.title}({p.value})
                        </Select.Option>)}
                    </Select>
                </Col>
                {this.renderError('projectName')}
            </Row>
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col>
                    <span>页面描述：</span>
                </Col>
                <Col flex='auto'>
                    <Input
                        size='small'
                        value={this.state.comment}
                        onChange={({ target: { value } }) => this.setState({ comment: value })}
                    />
                </Col>
            </Row>
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col>
                    <span>页面链接：</span>
                </Col>
                <Col flex='auto'>
                    <Input
                        size='small'
                        value={this.state.link}
                        onChange={({ target: { value } }) => this.setState({ link: value })}
                    />
                </Col>
            </Row>
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col>
                    {redStar}<span>覆盖应用端(可多选)：</span>
                </Col>
                <Col flex='auto'>
                    <Select
                        value={this.state.apps}
                        onChange={apps => this.setState({ apps, appsError: undefined })}
                        allowClear
                        mode="multiple"
                        size='small'
                        showSearch
                        style={{
                            width: '100%'
                        }}
                    >
                        {this.currentApps().map(app => <Select.Option key={app.value} value={app.value}>
                            {app.title}({app.value})
                        </Select.Option>)}
                    </Select>
                </Col>
                {this.renderError('apps')}
            </Row>
            <Row style={{ margin: '0 0 20px 0' }}>
                <Col style={{ alignSelf: 'center' }}>
                    <span>页面图片：</span>
                </Col>
                <Col style={{ alignSelf: 'center' }}>
                    {this.renderUploader()}
                </Col>
                {isNotEmpty(this.state.pictureStorageKey) && <Col style={{ alignSelf: 'center' }}>
                    <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => this.setState({ pictureStorageKey: undefined })}
                    />
                </Col>}
            </Row>
            {isNotEmpty(this.state.pictureStorageKey) && <Row justify='center'>
                <Col flex='80%'>
                    <Image
                        src={`/api/v1/sampling/pictures/preview?key=${encodeURI(this.state.pictureStorageKey)}`}
                        height={300}
                    />
                </Col>
            </Row>}
        </Modal>
    }

    async componentDidMount() {
        if (isNotEmpty(this.props.pageId)) {
            const page = await UIFetchService.get(`/api/v1/sampling/pages/${this.props.pageId}`);
            this.setState({ ...page });
        } else {
            if (isNotEmpty(this.props.projectName)) {
                this.setState({ projectName: this.props.projectName });
            }
        }
    }

    renderError(key) {
        if (isNotEmpty(this.state[key + 'Error'])) {
            return <>
                <Col flex='100%'>
                    <span style={{ color: 'red' }}>{this.state[key + 'Error']}</span>
                </Col></>;
        }
        return <></>;
    }

    currentApps() {
        const project = samplingConstants.projects.find(p => p.value === this.state.projectName);
        if (project) {
            return project.children;
        } else {
            return [];
        }
    }

    renderUploader() {
        return <Upload
            name="file"
            action={`/api/v1/sampling/pictures/temp_media_file`}
            accept="image/png,image/jpg,image/jpeg"
            maxCount={1}
            showUploadList={false}
            onChange={info => this.uploadingDidChanged(info)}
            beforeUpload={file => {
                return true;
            }}
        >
            <Button
                danger
                icon={<CloudUploadOutlined />}
                type="link"
                size="small"
                style={{ color: '#1890ff' }}
            ></Button>
        </Upload>;
    }

    async save() {
        if (!(await this.check())) {
            message.error('设置错误，不能保存');
            return;
        }

        await UIFetchService.put(`/api/v1/sampling/pages/${this.state.id}`, this.state);
        message.success('更新成功。');
        this.props.onDone();
    }

    async add() {
        if (!(await this.check())) {
            message.error('设置错误，不能新建');
            return;
        }

        await UIFetchService.post('/api/v1/sampling/pages', this.state);
        message.success('新建成功。');
        this.props.onDone();
    }

    async check() {
        //console.log(this.state);
        const params = {};
        if (isEmpty(this.state.projectName)) {
            params.projectNameError = '所属项目组不能为空';
        }
        if (isEmpty(this.state.name)) {
            params.nameError = '页面名称不能为空'
        }
        if (isNotEmpty(this.state.name) && isNotEmpty(this.state.projectName)) {
            let query = `projectName=${this.state.projectName}`;
            query += `&name=${encodeURI(this.state.name)}`;
            query += `&excludeId=${this.state.id === undefined ? '' : this.state.id}`;
            const { id } = await UIFetchService.get(`/api/v1/sampling/pages/by_name?${query}`);
            if (typeof id === 'number') {
                params.nameError = '页面名称不能在同一所属项目下重复'
            } else {

            }
        }
        if (isEmpty(this.state.apps) || this.state.apps.length === 0) {
            params.appsError = '覆盖应用端不能为空';
        }
        this.setState(params);

        console.log(params);
        return Object.keys(params).length === 0;
    }

    uploadingDidChanged(info) {
        switch (info.file.status) {
            case 'uploading':
                break;
            case 'done':
                this.setState({ pictureStorageKey: info.file.response.key });
                break;
            case 'error':
                message.error('文件上传失败');
                break;
            default:
                break;
        }
    }
}


class PageAssociatedEventsModal extends React.Component {
    constructor() {
        super();
        this.state = {
            key: '',
            events: [],
            associatedKeys: []
        };
    }

    render() {
        return <Modal
            title='关联事件'
            {...this.props}
            maskClosable={false}
            width={1000}
            onOk={this.save.bind(this)}
        >
            <Row style={{ margin: '0 0 10px 0' }}>
                <Col flex='300px'>
                    <Input.Search
                        size='small'
                        placeholder='按事件名/事件标识搜索'
                        value={this.state.key}
                        onChange={({ target: { value } }) => this.refreshEvents(value)}
                    />
                </Col>
                <Col flex='auto' />
                {this.state.page !== undefined && <Col>
                    <Button
                        size='small'
                        href={`/real_time/sampling/new?projectName=${this.state.page.projectName}&associatedKeys=${this.state.page.id}`}
                    >先去注册埋点</Button>
                </Col>}
            </Row>
            <Row>
                <Col flex="100%">
                    <Table
                        dataSource={this.state.events}
                        bordered
                        size='small'
                        rowKey='id'
                        rowSelection={{
                            selectedRowKeys: this.state.associatedKeys,
                            onChange: associatedKeys => this.setState({ associatedKeys })
                        }}
                        scroll={{ x: 1200, y: 500 }}
                    >
                        <Table.Column
                            title='ID'
                            dataIndex='id'
                            key='id'
                            width={80}
                            render={id => <Tag>{id}</Tag>}
                        />
                        <Table.Column
                            title='事件标识'
                            dataIndex='name'
                            key='name'
                            ellipsis
                            width={200}
                        />
                        <Table.Column
                            title='事件名称'
                            dataIndex='nameChs'
                            key='nameChs'
                            ellipsis
                            width={120}
                        />
                        <Table.Column
                            title='事件类型'
                            dataIndex='type'
                            key='type'
                            width={140}
                            filters={samplingConstants.eventTypes.map(p => { return { text: p.title, value: p.value } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.type)) {
                                    return false;
                                }
                                return rd.type.indexOf(value) >= 0;
                            }}
                            render={(type, rd) => <Tooltip title={type}>
                                <span>
                                    {samplingConstants.eventTypes.find(t => t.value === type)?.title}
                                </span>
                            </Tooltip>}
                        />
                        <Table.Column
                            title='所属项目组'
                            dataIndex='projectName'
                            key='projectName'
                            width={120}
                            filters={samplingConstants.projects.map(p => { return { text: p.title, value: p.value } })}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.projectName)) {
                                    return false;
                                }
                                return rd.projectName.indexOf(value) >= 0;
                            }}
                            render={(projectName) => {
                                const project = samplingConstants.projects.find(p => p.value === projectName);
                                if (project) {
                                    return <span>{project.title}</span>
                                }
                            }}
                        />
                        <Table.Column
                            title='事件分组'
                            dataIndex='eventGroup'
                            key='eventGroup'
                            width={120}
                            filters={this.currentProjectGroups()}
                            onFilter={(value, rd) => {
                                if (isEmpty(rd.eventGroup)) {
                                    return false;
                                }
                                return rd.eventGroup.indexOf(value) >= 0;
                            }}
                        />
                        <Table.Column
                            title='所属页面'
                            dataIndex='pages'
                            key='pages'
                            width={250}
                            ellipsis
                            render={pages => {
                                switch (pages.length) {
                                    case 0:
                                        return <span style={{ color: 'gray', fontSize: 12 }}>[未关联页面]</span>;
                                    case 1:
                                        return <span>{pages[0].name}</span>;
                                    default:
                                        return <Popover
                                            title='所属页面'
                                            content={pages.map(page => <Row>
                                                <Col>{page.name}</Col>
                                            </Row>)}
                                        >
                                            <span>{pages[0].name} ...</span>
                                        </Popover>;
                                }
                            }}
                        />
                        <Table.Column
                            title='创建人员'
                            dataIndex='creatorName'
                            key='creatorName'
                            width={80}
                        />
                        <Table.Column
                            title='创建时间'
                            dataIndex='createdAt'
                            key='createdAt'
                            width={200}
                            sorter={(a, b) => {
                                if (a.createdAt > b.createdAt) {
                                    return 1;
                                } else if (a.createdAt < b.createdAt) {
                                    return -1;
                                } else {
                                    return 0;
                                }
                            }}
                        />
                        <Table.Column
                            title='更新人员'
                            dataIndex='updaterName'
                            key='updaterName'
                            width={80}
                        />
                        <Table.Column
                            title='更新时间'
                            dataIndex='updatedAt'
                            key='updatedAt'
                            width={200}
                            sorter={(a, b) => {
                                if (a.updatedAt > b.updatedAt) {
                                    return 1;
                                } else if (a.updatedAt < b.updatedAt) {
                                    return -1;
                                } else {
                                    return 0;
                                }
                            }}
                        />
                    </Table>
                </Col>
            </Row>
        </Modal>;
    }

    async componentDidMount() {
        const page = await UIFetchService.get(`/api/v1/sampling/pages/${this.props.pageId}`);
        this.setState({ page });
        await this.refreshEvents('');
    }

    currentProjectGroups() {
        if (this.state.projectsGroups === undefined) {
            return [];
        }
        if (isEmpty(this.props.projectName)) {
            const groups = [];
            for (let project of Object.keys(this.state.projectsGroups)) {
                for (let group of this.state.projectsGroups[project]) {
                    groups.push({ value: group, text: `${project} / ${group}` });
                }
            }
            return groups;
        }
        const groups = this.state.projectsGroups[this.props.projectName];
        if (isEmpty(groups)) {
            return [];
        } else {
            return groups.map(g => { return { value: g, text: g }; });
        }
    }

    async refreshEvents(key) {
        this.setState({ key });
        const rv = await UIFetchService.get(`/api/v1/sampling/pages/${this.props.pageId}/associated_events${isNotEmpty(key) ? `?key=${key}` : ''}`);
        if (rv) {
            this.setState({ ...rv });
        }
        const projectsGroups = await UIFetchService.get('/api/v1/sampling/projects/groups');
        this.setState({ projectsGroups });
    }

    async save() {
        await UIFetchService.put(`/api/v1/sampling/pages/${this.props.pageId}/associated_events`, this.state.associatedKeys);
        message.success('页面到事件关联完成。');
        this.props.onDone();
    }
}

export default SamplingPageView;